module.exports = __webpack_public_path__ + "static/ana-ca87aa55ab2d9a8cde8842e42139875f.jpg";